/**
 * MILQ header — mega-menu feature strips.
 *
 * A split mega menu can render one strip of article images per sub-link
 * (see sections/header-link.liquid). Hovering a sub-link brings its strip to the
 * front. The markup ships with the first strip already active, so this script only
 * ever swaps which one is shown — if it fails to load the panel still renders.
 */
(function () {
  'use strict';

  var LINK_SELECTOR = '.sub-nav--link[data-auto-target]';
  var GROUP_SELECTOR = '.nav-features--auto-group';
  var ACTIVE_CLASS = 'is-active';

  function activate(subNav, key) {
    var groups = subNav.querySelectorAll(GROUP_SELECTOR);
    if (!groups.length) return;

    var match = null;
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].getAttribute('data-auto-features') === key) {
        match = groups[i];
        break;
      }
    }

    // Sub-links with no strip of their own (e.g. Boutique) hold the default rather
    // than blanking the right-hand side.
    if (!match) match = groups[0];

    for (var j = 0; j < groups.length; j++) {
      groups[j].classList.toggle(ACTIVE_CLASS, groups[j] === match);
    }
  }

  function onPointerOver(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest(LINK_SELECTOR);
    if (!link) return;

    var subNav = link.closest('.sub-nav');
    if (!subNav) return;

    activate(subNav, link.getAttribute('data-auto-target'));
  }

  // mouseover bubbles (mouseenter does not), so one delegated listener on document
  // covers every dropdown and survives Turbolinks swapping the body.
  document.addEventListener('mouseover', onPointerOver);
})();
